import { graphql } from "@/gql";

export const supplierBookingStatBlockQuery = graphql(`
  query SupplierBookingStatBlock(
    $supplierId: ID!
    $start: DateTime!
    $end: DateTime!
    $comparisonMode: ComparisonMode!
  ) {
    supplierBookingStatBlock(
      supplierId: $supplierId
      start: $start
      end: $end
      comparisonMode: $comparisonMode
    ) {
      pending_count
      confirmed_count
      completed_count
      cancelled_count
      successful_bookings_trend
      avg_confirmation_hours
      avg_confirmation_hours_trend
    }
  }
`);
